const queryString = require('query-string');

import React from 'react';
import axios from 'axios';
import { baseUrl } from 'Config';
import store from 'store';
import AuthService from '@services/AuthService';

class LoginApi extends React.Component {
    constructor(props) {
        super(props);

        this.state = { loaded: false };
        
        this.qString = queryString.parse(this.props.location.state.from.search);
        this.url = this.qString && this.qString.url ? this.qString.url : null;

        store.set('CorlyticsApiLogin', true);
    }
    
    componentDidMount() {
        this.login();
    }
    
    login() {
        const location = this.props.location;
        
        axios({
            method: 'POST',
            url: baseUrl + '/auth/api_login',
            data: { 'api-key': this.qString['api-key'] }
        })
        .then(response => {
            AuthService.loginSuccessResponse(response.data);
            this.setState({ loaded: true });
            
            if (!this.url && (!location.state || location.pathname === location.state.from.pathname)) {
                this.props.history.push('/');
            }
            else {
                this.props.history.push(this.url ? this.url : location.state.from.pathname + location.state.from.search)
            }
        })
        .catch(error => {
            console.log(error)
            // this.setState({ loaded: true });            
            // return this.props.history.push('/login');
        });
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row mt-4 ml-4">
                    <div className="col" style={{fontSize: '1.2rem'}}>Redirecting...</div>
                </div>
            </div>
        )
    }    
}
export default LoginApi;


// WEBPACK FOOTER //
// ./src/views/Pages/Login/LoginApi.js